import { SearchPageType } from '@zoopla/listing-search-context';
import { zooplaTheme as theme } from '@blueprint/theme';

type Color = keyof typeof theme.colors;
type IconSize = keyof typeof theme.iconSize;
type TextSize =
    | 'body'
    | 'secondary'
    | 'small'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8';

type IconAndTextProps = {
    content?: number | null;
    iconColor?: Color;
    iconStrokeColor?: Color;
    iconId?: string | null;
    /** @default 'true' */
    isInline?: boolean;
    /** @default 'grey-steel' */
    contentColor?: Color;
    size?: IconSize;
    textSize?: TextSize;
    className?: string;
    isBold?: boolean;
    margin?: string;
};

type TransportProps = {
    poiType?: string | null;
    distanceInMiles?: number | null;
    title?: string | null;
};

type tags = {
    content?: string | null;
};

type branch = {
    branchDetailsUri?: string | null;
    logoUrl?: string | null;
    name?: string | null;
    phone?: string | null;
    branchId?: number | null;
};

export type ImageProps = {
    src?: string | null;
    caption?: string | null;
    responsiveImgList?:
        | ({
              width?: number | null;
              src?: string | null;
          } | null)[]
        | null;
};

export type SubImage = {
    small?: string | null;
    large?: string | null;
    caption?: string | null;
};

export type SubImageComponent = {
    key: string;
    src: string;
    selected: boolean;
    title: string;
};

type Highlights = {
    description?: boolean | string | null;
    label?: string | null;
    url?: boolean | string | null;
};

export enum DisplayType {
    STANDARD = 'standard'
}

type ListingType = {
    [key in DisplayType]: string;
};

type ListingUris = {
    contact?: string | null;
    detail?: string | null;
};

type PriceDrop = {
    lastPriceChangeDate: string;
    percentageChangeLabel: string;
};

export enum HaloType {
    PREMIUM,
    FEATURED,
    NONE
}

export type Props = {
    listingId: string;
    flag: string | null;
    image: ImageProps | null;
    branch: branch | null;
    numberOfVideos: number | null;
    numberOfFloorPlans: number | null;
    numberOfImages: number | null;
    isHelpToBuy?: boolean;
    priceTitle?: string;
    price: string;
    alternativeRentFrequencyLabel?: string;
    isPremium: boolean;
    underOffer?: boolean;
    priceDrop?: PriceDrop | null;
    displayType?: ListingType;
    otherPropertyImages: (SubImage | null)[] | null;
    highlights: (Highlights | null)[] | null;
    features: (IconAndTextProps | null)[] | null;
    title: string;
    address: string;
    transports: (TransportProps | null)[];
    tags: (tags | null)[];
    publishedOnLabel: string;
    publishedOn: string;
    numberOfViews: number | null;
    isFavourite: boolean;
    onSaveClick: () => void;
    contactOnClick?: () => void;
    phoneOnClick?: () => void;
    phoneRevealOnClick?: () => void;
    imageOnClick?: () => void;
    titleOnClick?: () => void;
    priceOnClick?: () => void;
    descriptionOnClick?: () => void;
    specOnClick?: () => void;
    transportInfoOnClick?: () => void;
    cardOnClick?: () => void;
    onCardEcommerceClick?: () => void;
    agentLogoOnClick?: () => void;
    removeFavouriteLabel: string;
    saveFavouriteLabel: string;
    viewsLabel: string;
    viewsPeriodLabel: string;
    listingUris?: ListingUris | null;
    searchIdentifier?: string;
    availableFrom?: string;
    availableFromLabel?: string;
    searchType?: SearchPageType;
    overrideViewsWithAvailability?: boolean;
    'data-testid'?: string;
    className?: string;
    useLazyImage?: boolean;
    showHalo: boolean;
    presentationType?: string;
};
